import {
  browserSupabaseClient,
  createBrowserSupabaseClient,
  getSupabaseBrowserEnv,
} from "./supa.client";

export {
  browserSupabaseClient,
  createBrowserSupabaseClient,
  getSupabaseBrowserEnv,
};

export function getBrowserSupabaseClient() {
  return browserSupabaseClient;
}
